import { RevenueCodeEntry } from '../../types/supply'
import { adminCollectionAccess } from '../constants'
import { REVENUE_CODES } from '../names'
import { FirestoreCollection } from '../types'

export const revenueCodesCollection: FirestoreCollection<RevenueCodeEntry> = {
  id: 'revenueCodes',
  _type: 'firestoreCollection',
  name: 'Revenue Codes',
  refPath: REVENUE_CODES,
  access: adminCollectionAccess,
  defaultSort: 'code',
}
